module.exports = __webpack_public_path__ + "media/src/images/icon/mypage-39943a762d3a078dd1c2454537f5b2be.png";